if (typeof window !== 'undefined' && !window.IntersectionObserver) {
  require('intersection-observer');
}